@if(mentorStatusCount(); as statusCount) {
<h4>Required Mentors</h4>
<table class='pro-table pro-table-without-border pro-table-with-thin-rows w-100'>
	<tr>
		<th>Language</th>
		<th>Count</th>
	</tr>
	<tr>
		<td>English</td>
		<td>{{statusCount.requiredMentors.english}}</td>
	</tr>
	<tr>
		<td>Spanish</td>
		<td>{{statusCount.requiredMentors.spanish}}</td>
	</tr>
</table>

<hr>

<h4>Mentor Sign ups</h4>
<table class='pro-table pro-table-without-border pro-table-with-thin-rows w-100'>
	<tr>
		<th>Language</th>
		<th>Count</th>
	</tr>
	<tr>
		<td>English</td>
		<td>{{statusCount.pendingMentors.EN}}</td>
	</tr>
	<tr>
		<td>Spanish</td>
		<td>{{statusCount.pendingMentors.ES}}</td>
	</tr>
	<tr>
		<td>Either</td>
		<td>{{statusCount.pendingMentors.both}}</td>
	</tr>
</table>

<hr>

<h4>Assigned Mentors</h4>
<table class='pro-table pro-table-without-border pro-table-with-thin-rows w-100'>
	<tr>
		<th>Language</th>
		<th>Count</th>
	</tr>
	<tr>
		<td>English</td>
		<td>{{statusCount.assignedMentors.english}}</td>
	</tr>
	<tr>
		<td>Spanish</td>
		<td>{{statusCount.assignedMentors.spanish}}</td>
	</tr>
</table>
}